import axios from "axios";
import {SERVER_URL, PUBLIC_URL, LOGIN_URL} from './cons'


class RequestHelper {
    constructor() {
        this.BASE_URL = SERVER_URL + PUBLIC_URL;
        this.conf = null;
        this.token = null;
        this.activeRequests = 0;
    }

    parseCookie() {
        return document.cookie.split('; ').reduce((prev, current) => {
            const [name, ...value] = current.split('=');
            prev[name] = value.join('=');
            return prev;
        }, {});
    }

    setToken(token) {
        this.token = token;
        this.conf = {headers: {Authorization: `Bearer ${token}`}};

        // Keep a non-HttpOnly fallback for local development. Production auth
        // is normally carried by the server-set HttpOnly cookie.
        const expires = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `token=${encodeURIComponent(token)};expires=${expires};path=/;SameSite=Lax`;
    }

    /**
     * 
     * @param {function} func hàm gọi
     * @param {array} args danh sách tham số
     * @returns giá trị nhận được từ server
     */
    wrapperExcute = async (func, args, { showMask = true } = {}) => {
        const masks = document.getElementById('mask');
        try {
            if (this.startRequest) this.startRequest();
            if (showMask) {
                this.activeRequests += 1;
                if (masks) masks.classList.add("is-visible");
            }
            const cookie = this.parseCookie();
            const token = this.token || cookie.token;
            let axiosConfig = {};
            if (token) {
                axiosConfig.headers = {
                    'authorization': 'Bearer ' + decodeURIComponent(token),
                }
            }
            let response = await func(...args, axiosConfig);
            return response.data;
        } catch(ex) {
            this.handleError(ex);
            return null;
        }
        finally {
            if (showMask) {
                this.activeRequests = Math.max(0, this.activeRequests - 1);
                if (!this.activeRequests && masks) masks.classList.remove("is-visible");
            }
            if (this.stopRequest) this.stopRequest();
        }
    }

    onError(message) {
        if (typeof window !== "undefined" && typeof window.CustomEvent === "function") {
            window.dispatchEvent(new window.CustomEvent("workplace:request-error", { detail: message }));
        }
        console.error(message);
    }

    handleError(ex) {
        if (ex instanceof EvalError) {
            window.location.href = LOGIN_URL;
        }
        const status = ex?.response?.status;
        if (status === 401) {
            //window.location.href = LOGIN_URL;
            return;
        }
        if (status === 404) {
            this.onError("Xin lỗi! Đường dẫn truy cập không tồn tại!");
            return;
        }
        if (status === 500) {
            this.onError("Xin lỗi! Có lỗi hệ thống. Vui lòng thông báo với quản trị viên để biết thông báo về lỗi này.");
            return;
        }
        this.onError(ex?.response?.data?.message || ex?.message || "Không thể kết nối đến hệ thống.");
        //throw ex;
    }

    /**
     * Get an object by url
     * @param {String} url url
     * @param {Object} query object query
     * @returns get json data
     */
    get = async (url, query=null, options={}) => {
        var queryString = query == null ? "" : new URLSearchParams(query).toString();
        queryString = !queryString ? "" : '?' + queryString;
        return await this.wrapperExcute(axios.get, [this.BASE_URL + url + queryString], options);
    }

    /**
     * Gọi api edit
     * @param {string} url đường dẫn
     * @param {Object} postData dữ liệu post
     * @returns giá trị sau khi post
     */
    post = async(url, postData, options={}) => {
        return await this.wrapperExcute(axios.post, [this.BASE_URL + url, postData], options);
    }

    /**
     * Gọi api add
     * @param {string} url đường dẫn
     * @param {Object} postData dữ liệu post
     * @returns giá trị sau khi post
     */
    put = async(url, putData, options={}) => {
        return await this.wrapperExcute(axios.put, [this.BASE_URL + url, putData], options);
    }

    /**
     * Gọi api delete
     * @param {string} url đường dẫn
     * @param {Object} id dữ liệu dòng muốn xoá
     * @returns giá trị sau khi post
     */
    delete = async(url, options={}) => {
        return await this.wrapperExcute(axios.delete, [this.BASE_URL + url], options);
    }

    download = async(url, query) => {
        try {
            var queryString = query == null ? "" : Object.keys(query).map(key => key + '=' + query[key]).join('&');
            queryString = !queryString ? "" : '?' + queryString;
            const cookie = this.parseCookie();
            const response = await axios.get(this.BASE_URL + url + queryString, {
                headers: {
                    'Authorization': cookie.token,
                },
                responseType: 'blob'
            });
            const downloadURL = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadURL;

            link.setAttribute('download', 'baocao.xlsx');
            document.body.appendChild(link);
            link.click();
        } catch (ex) {
            this.handleError(ex);
        }
    }
}

const requestHelper = new RequestHelper();

export default requestHelper;
